import axiosConfig from './axiosConfigInstance';

const SESSION_KEY = 'manage_subscription_session_id';

const getSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = `manage_sub_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return `manage_sub_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }
};

export const trackManageSubscriptionEvent = (payload = {}) => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');

    const body = {
      sessionId: getSessionId(),
      eventName: payload.eventName,
      eventAction: payload.eventAction || 'click',
      subscriptionId: payload.subscriptionId,
      planId: payload.planId,
      billingCycle: payload.billingCycle,
      page: payload.page || window.location.pathname,
      email: payload.email || userData.email,
      userId: payload.userId || userData._id || userData.id || userData.userId,
      source: payload.source || 'manage_subscription_page',
      clientTimestamp: new Date().toISOString(),
      meta: payload.meta || {},
    };

    return axiosConfig
      .post(`${import.meta.env.VITE_APP_API_URL}/chargebee/manage-subscription-click`, body)
      .catch(() => null);
  } catch {
    return Promise.resolve(null);
  }
};
